import { render, staticRenderFns } from "./history-purchase.vue?vue&type=template&id=c2c9f94c"
import script from "./history-purchase.vue?vue&type=script&lang=js"
export * from "./history-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports